import React from 'react';
import { Link } from 'react-router-dom';
import { Globe } from 'lucide-react';
import useConsentPreference from '../../hooks/useConsentPreference';

/**
 * Footer Component
 * Site footer with links and copyright information
 */
export default function Footer() {
  const { openPreferences } = useConsentPreference();

  return (
    <footer className="border-t border-gray-200 mt-12 sm:mt-16">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-8 sm:py-12">
        <div className="grid grid-cols-1 md:grid-cols-3 gap-8 mb-6 sm:mb-8 justify-items-center md:justify-items-start max-w-3xl mx-auto">
          <div className="text-center md:text-left">
            <h3 className="font-semibold mb-4">Support</h3>
            <ul className="space-y-3 text-sm text-gray-600">
              <li><Link to="/help" className="hover:underline" onClick={() => window.scrollTo(0, 0)}>Help Center</Link></li>
              <li><Link to="/safety" className="hover:underline" onClick={() => window.scrollTo(0, 0)}>Safety information</Link></li>
              <li><Link to="/cancellation-options" className="hover:underline" onClick={() => window.scrollTo(0, 0)}>Cancellation options</Link></li>
            </ul>
          </div>
          <div className="text-center md:text-left">
            <h3 className="font-semibold mb-4">Guiding</h3>
            <ul className="space-y-3 text-sm text-gray-600">
              <li><Link to="/guides/signup" className="hover:underline" onClick={() => window.scrollTo(0, 0)}>Become a guide</Link></li>
            </ul>
          </div>
          <div></div>
        </div>

        <div className="pt-6 sm:pt-8 border-t border-gray-200 flex flex-col items-center space-y-4 text-center">
          <div className="flex flex-col sm:flex-row items-center space-y-2 sm:space-y-0 sm:space-x-4 text-sm text-gray-600">
            <span>© {new Date().getFullYear()} Outdoor Guides</span>
            <span className="hidden sm:inline">·</span>
            <Link to="/privacy" className="hover:underline" onClick={() => window.scrollTo(0, 0)}>Privacy</Link>
            <span className="hidden sm:inline">·</span>
            <Link to="/terms" className="hover:underline" onClick={() => window.scrollTo(0, 0)}>Terms</Link>
            <span className="hidden sm:inline">·</span>
            <button type="button" onClick={openPreferences} className="hover:underline">Privacy Settings</button>
          </div>
          <div className="flex items-center">
            <button className="flex items-center space-x-2 text-sm font-medium hover:underline">
              <Globe className="w-4 h-4" />
              <span>English (US)</span>
            </button>
          </div>
        </div>
      </div>
    </footer>
  );
}
